import { render, staticRenderFns } from "./ModalShipmentDetailEdit.vue?vue&type=template&id=3ed0d5c0&lang=pug&"
import script from "./ModalShipmentDetailEdit.vue?vue&type=script&lang=js&"
export * from "./ModalShipmentDetailEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports